import React from "react";
import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, y = 40, className = "", once = true }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-80px" }}
      transition={{ duration: 0.9, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

// Masked line-by-line reveal for editorial headings.
// `emphasis` italicizes that phrase wherever it appears in a line.
export function MaskedLines({ lines, className = "", lineClassName = "", start = 0.1, stagger = 0.12, emphasis = "", bigWords = [], sizeByLine = {} }) {
  const bigSet = new Set(bigWords.map((w) => w.toLowerCase()));
  const renderLine = (line) => {
    if (bigSet.size) {
      return line.split(/(\s+)/).map((tok, i) => {
        const base = tok.toLowerCase().replace(/[^a-z]/g, "");
        if (base && bigSet.has(base)) {
          return (
            <em key={i} className="hero-emph italic font-normal" style={{ fontSize: "1.5em" }}>{tok}</em>
          );
        }
        return <React.Fragment key={i}>{tok}</React.Fragment>;
      });
    }
    if (emphasis && line.includes(emphasis)) {
      const [before, after] = line.split(emphasis);
      return (
        <>
          {before}
          <em className="italic font-normal">{emphasis}</em>
          {after}
        </>
      );
    }
    return line;
  };
  return (
    <span className={className} aria-label={lines.join(" ")}>
      {lines.map((line, i) => (
        <span key={i} className="reveal-mask" aria-hidden="true">
          <motion.span
            className={`block ${lineClassName}`}
            style={sizeByLine[i] ? { fontSize: sizeByLine[i] } : undefined}
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1, delay: start + i * stagger, ease: EASE }}
          >
            {renderLine(line)}
          </motion.span>
        </span>
      ))}
    </span>
  );
}

export { EASE };
